// =======================================================================
// モーダル（modaal.min.jsの設定）
// =======================================================================
//news
$(function() {
$(".modaal").modaal({
//オプション
  background: "#8aafc2", // overlayの色の設定
  overlay_opacity: "0.8", // overlayの透過量
});
$('.modaal_close').click(function(){
  $('.modaal').modaal('close');
});
});

//recruit staff
$(function() {
$(".staff_modaal").modaal({
//オプション
  background: "#8aafc2", // overlayの色の設定
  overlay_opacity: "0.8", // overlayの透過量
}
);
$('.staff_modaal_close').click(function(){
  $('.staff_modaal').modaal('close');
});
});

